// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { fulfillmentCycleTimeReportSchema } from '@/fulfillment/api/types';
import type { CycleTimeReportFilter } from '@/report/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';
import queryString from 'query-string';
import { z } from 'zod';

const fulfillmentCycleTimeReportResponseSchema = z.object({
  data: fulfillmentCycleTimeReportSchema,
  metadata: responseMetadataSchema,
});

type FulfillmentCycleTimeReportResponse = z.infer<
  typeof fulfillmentCycleTimeReportResponseSchema
>;

export function serializeFulfillmentCycleTimeReportFilter(
  filter?: CycleTimeReportFilter
): string {
  if (!filter) {
    return '';
  }

  return queryString.stringify({
    startDate: serializeDateForAPI(filter.interval.start),
    endDate: serializeDateForAPI(filter.interval.end),
  });
}

export async function getFulfillmentCycleTimeReport(
  filter?: CycleTimeReportFilter
): Promise<FulfillmentCycleTimeReportResponse> {
  const url = '/v1/report/fulfillment/cycle-time';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: {
      startDate: serializeDateForAPI(filter?.interval.start),
      endDate: serializeDateForAPI(filter?.interval.end),
    },
  });

  return parseResponse(
    fulfillmentCycleTimeReportResponseSchema,
    response.data,
    {
      schemaName: 'FulfillmentCycleTimeReport',
      endpoint: url,
    }
  );
}
